import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { passengerHost } from "~/Utils";

interface DocumentDetailsResponse {
  id: string,
  title: string;
  field_page_banner_image: string;
  field_page_title_en: string;
  field_page_title_ms: string;
  field_page_title_zh: string;
  field_page_description_en: string;
  field_page_description_ms: string;
  field_page_description_zh: string;
  field_page_metadata_title_en: string;
  field_page_metadata_title_ms: string;
  field_page_metadata_title_zh: string;
  field_page_meta_description_en: string;
  field_page_meta_description_ms: string;
  field_page_meta_description_zh: string;
  field_page_header_metadata_image: string;
  field_page_header_airport: string;
  field_page_header_name: string;
  field_page_header_display_path: string;
  status: boolean;
  published: boolean;
}

const fetchHelpHeadingDetails = async (id: string): Promise<DocumentDetailsResponse> => {
  const response = await axios.get(`${passengerHost}/api/page-headers/${id}`);
  console.log(response.data[0],"tested")
  return response.data[0]; 
};

const useHelpHeadingDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError>({
    queryKey: ["HelpHeadingDocumentDetails", id],
    enabled: !!id,
    queryFn: () => fetchHelpHeadingDetails(id),
    refetchOnWindowFocus: false,
    ...options,
  }, queryClient);
};


export { useHelpHeadingDocumentDetails };

